export const isAnswerSubmitted = (item) => {
  if (!item || typeof item !== "object") return false;
  if (item.isSubmitted !== undefined) return Boolean(item.isSubmitted);
  return Boolean(item.is_submitted);
};

export const addSubmissionFieldAliases = (answer) => {
  if (!Array.isArray(answer)) return answer;

  return answer.map((item) => {
    if (!item || typeof item !== "object" || Array.isArray(item)) return item;

    const aliasedItem = { ...item };
    const fieldPairs = [
      ["isSubmitted", "is_submitted"],
      ["isCorrect", "is_correct"],
    ];

    fieldPairs.forEach(([camelCase, snakeCase]) => {
      if (item[camelCase] === undefined && item[snakeCase] === undefined) return;

      const value =
        item[camelCase] !== undefined ? item[camelCase] : item[snakeCase];
      aliasedItem[camelCase] = value;
      aliasedItem[snakeCase] = value;
    });

    return aliasedItem;
  });
};

export const normalizeSectionSubmissionFields = (section) => {
  if (!section || typeof section !== "object") return section;

  return {
    ...section,
    answer: addSubmissionFieldAliases(section.answer),
  };
};
